import { lazy } from 'react';


export const Student = lazy(() => import('./Student'));
